import { render, staticRenderFns } from "./Regatta.vue?vue&type=template&id=975c6b6c&scoped=true&"
import script from "./Regatta.vue?vue&type=script&lang=js&"
export * from "./Regatta.vue?vue&type=script&lang=js&"
import style0 from "./Regatta.vue?vue&type=style&index=0&id=975c6b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975c6b6c",
  null
  
)

export default component.exports